import { create } from 'zustand';
import { HotelSearchFilterModel } from '../hotelSearch/types/HotelSearch/HotelSearchFilterModel';
import { HotelSearchQuery } from '../hotelSearch/types/HotelSearch/HotelSearchQuery';

export const defaultHotelSearchFilterModel: HotelSearchFilterModel = {
  SortBy: 'price',
  BrandFilter: '',
  ChainCodeFilter: '',
  RangeFilter: undefined,
  MinPriceFilter: undefined,
  MaxPriceFilter: undefined,
  AmenityFilter: [],
  Amenities: [],
  RecentlyBooked: false,
};

type HotelBookingState = {
  hotelSearchQuery: HotelSearchQuery | undefined;
  hotelFilters: HotelSearchFilterModel | undefined;
  setSearchQuery: (query: HotelSearchQuery | undefined) => void;
  setHotelFilters: (filters: HotelSearchFilterModel | undefined) => void;
  resetHotelFilters: () => void;
};

export const useHotelBookingStore = create<HotelBookingState>((set) => ({
  hotelSearchQuery: undefined,
  hotelFilters: undefined,
  setHotelFilters: (filters: HotelSearchFilterModel | undefined) => set({ hotelFilters: filters }),
  setSearchQuery: (query: HotelSearchQuery | undefined) => set({ hotelSearchQuery: query }),
  resetHotelFilters: () => set({ hotelFilters: defaultHotelSearchFilterModel })
}));
